import { render, staticRenderFns } from "./credit-regist.vue?vue&type=template&id=20d6fa60&scoped=true&"
import script from "./credit-regist.vue?vue&type=script&lang=js&"
export * from "./credit-regist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d6fa60",
  null
  
)

export default component.exports